// ----------------------------------------------------------------------
// <copyright file="Izenda.GridLayout.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  const { omit } = require('lodash/fp');

  var MAX_COLS = 12;
  var React = require('react');
  var classnames = require('classnames');

  var GridLayout = createGridLayoutElement('izenda-GridLayout');
  GridLayout.displayName = 'GridLayout';

  GridLayout.Row = createGridLayoutElement('izenda-GridLayout-Row');
  GridLayout.Row.displayName = 'GridLayout.Row';

  GridLayout.FullRow = createGridLayoutElement('izenda-GridLayout-Row_full');
  GridLayout.FullRow.displayName = 'GridLayout.FullRow';



  GridLayout.Col = function(props) {
    var cols = props.cols || MAX_COLS;
    var colClass = 'izenda-GridLayout-Col' + cols;
    var xsColclass = props.xs && 'izenda-GridLayout-Col' + props.xs + '-xs';
    var offsetClass = props.offset && 'izenda-GridLayout-ColOffset' + props.offset;

    var className = classnames(colClass, xsColclass, offsetClass);
    var restProps = omit(['cols', 'offset', 'xs'], props);
    return createGridLayoutElement(className)(restProps);
  };
  GridLayout.Col.displayName = 'GridLayout.Col';

  function createGridLayoutElement(className) {
    return function(props) {
      var clazz = classnames(className, props.className);
      var restProps = omit('className', props);
      return (
        <div className={clazz} {...restProps}>
          {props.children}
        </div>
      );
    };
  }

  module.exports = GridLayout;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.GridLayout.jsx